module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "questionBox"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "loader": "dots",
      "color": "#1f9ed3",
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('main', {
    staticClass: "main-form"
  }, [_c('form', {
    attrs: {
      "name": "userInfo"
    }
  }, [_c('table', {
    staticClass: "main-table"
  }, [_c('tr', [_c('td', [_vm._v("Họ tên *:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Số CMND*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardid),
      expression: "cardid"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.cardid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Di động*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cellphone),
      expression: "cellphone"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cellphone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Email*:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "value": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo($event)
      }
    }
  }, [_vm._v("Gửi")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("Bỏ qua>>")])])])]), _vm._v(" "), _c('p', [_vm._v("Tìm hiểu thêm về thể lệ chương trình khuyến mại "), _c('a', {
    on: {
      "click": _vm.jumpActive
    }
  }, [_vm._v("tại đây")]), _vm._v("!")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header-banner"
  }, [_c('img', {
    staticClass: "activeImg",
    attrs: {
      "src": require("../assets/image/active2019.jpg"),
      "alt": "active"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activeImg_tips"
  }, [_vm._v("0h ngày 05/11/2018 đến 0h ngày 30/06/2019")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n    Chỉ bằng cách điền các thông tin dưới đây sẽ có thể tham gia chương trình khuyến mại cùng\n    "), _c('a', {
    attrs: {
      "href": "http://www.vngaynay.vn",
      "target": "blank"
    }
  }, [_vm._v("www.vngaynay.vn")]), _vm._v(" và có cơ hội nhận xe máy Wave RSX FI 2017 hoặc Điện thoại iPhone X 64GB Gray!\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c47528a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 1001
// module chunks = 1